import React from 'react';
import { motion } from 'framer-motion';
import { bodyParagraphs } from '../../config/infoCards';

const easeOut = [0.22, 1, 0.36, 1];

const InfoCard = ({ icon: Icon, title, body, footer, index = 0, reduceMotion }) => {
  const paragraphs = bodyParagraphs(body);

  const content = (
    <>
      <div className="info-card-icon" aria-hidden="true">
        <Icon size={28} strokeWidth={1.75} />
      </div>
      <h3 className="info-card-title">{title}</h3>
      <div className="info-card-body">
        {paragraphs.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </div>
      {footer ? <div className="info-card-footer">{footer}</div> : null}
    </>
  );

  if (reduceMotion) {
    return <article className="info-card site-card">{content}</article>;
  }

  return (
    <motion.article
      className="info-card site-card"
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.55, delay: index * 0.08, ease: easeOut }}
      whileHover={{ y: -6, transition: { type: 'spring', stiffness: 360, damping: 22 } }}
    >
      {content}
    </motion.article>
  );
};

export default InfoCard;
